<div
  class="daxa-form ml-auto mr-auto border-radius bg-white"
  [class.card-borderd-theme]="themeService.isCardBorder()"
  [class.component-dark-theme]="themeService.isDark()"
  [class.rtl-enabled]="themeService.isRTLEnabled()"
>
  <div class="title text-center">
    <h3>
      Ingresar
    </h3>
    <!-- @TODO -->
    <!-- <p class="text-black">
      No tienes cuenta todavía? <a routerLink="/auth/sign-up" class="text-daxa">Registro</a>
    </p> -->
  </div>
  <form
    [formGroup]="form"
    novalidate=""
    (ngSubmit)="submit(form)"
  >
    <div class="form-group">
      <!-- <label class="main-label d-block lh-1 text-black">
        E-mail
      </label> -->
      <mat-form-field>
        <mat-label>
          E-mail
        </mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>
      <div
        *ngIf="form.get('email')!.hasError('required') && form.get('email')!.touched"
        class="error text-danger"
      >
        Email is required.
      </div>
      <div
        *ngIf="form.get('email')!.hasError('email') && form.get('email')!.touched"
        class="error text-danger"
      >
        Please enter a valid email address.
      </div>
    </div>
    <div class="form-group">
      <!-- <label class="main-label d-block lh-1 text-black">
        Contraseña
      </label> -->
      <mat-form-field>
        <mat-label>
          Contraseña
        </mat-label>
        <input
          matInput
          [type]="hidePassword ? 'password' : 'text'"
          formControlName="password"
        />
        <button
          mat-icon-button
          matSuffix
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hidePassword"
          (click)="hidePassword = !hidePassword"
        >
          <span class="material-symbols-outlined">
            {{ hidePassword ? 'visibility_off' : 'visibility' }}
          </span>
        </button>
      </mat-form-field>
      <div
        *ngIf="form.get('password')!.hasError('required') && form.get('password')!.touched"
        class="error text-danger"
      >
        Password is required.
      </div>
      <div
        *ngIf="form.get('password')!.hasError('minlength') && form.get('password')!.touched"
        class="error text-danger"
      >
        Password must be at least 8 characters long.
      </div>
    </div>
    <button
      mat-button
      type="submit"
      class="btn"
      [disabled]="form.invalid"
    >
      Ingresar
    </button>
    <!-- <div class="info d-flex justify-content-between align-items-center"> -->
    <div class="info text-right">
      <!-- <mat-checkbox>
        Recordar
      </mat-checkbox> -->
      <!-- @TODO -->
      <!-- <a routerLink="/authentication/forgot-password" class="d-inline-block text-daxa">
        Olvidaste tu contraseña?
      </a> -->
    </div>
    <!-- <div class="signin-with-socials text-center">
      <div class="or position-relative">
        <span class="d-inline-block">
          o ingresar con
        </span>
      </div>
      <div class="socials">
        <button mat-button type="button" class="facebook">
          <i class="ri-facebook-fill"></i>
        </button>
        <button mat-button type="button" class="twitter">
          <i class="ri-twitter-x-fill"></i>
        </button>
        <button mat-button type="button" class="google">
          <i class="ri-google-fill"></i>
        </button>
        <button mat-button type="button" class="linkedin">
          <i class="ri-linkedin-fill"></i>
        </button>
      </div>
    </div> -->
  </form>
</div>
